import React from 'react';
import PropTypes from 'prop-types';

import SearchBar from "components/List/components/SearchBar";

OrderSearchBar.propTypes = {
    search: PropTypes.string,
    setSearch: PropTypes.func
};

function OrderSearchBar({search, setSearch = value => {}}) {
    return (
        <SearchBar
            customPlaceholder='oms.order.list.search.placeholder'
            value={search}
            onChange={(value) => setSearch(value)}
            style={{
                minWidth: '360px',
                '& input': {
                    height: '16px'
                }
            }}
        />
    );
}

export default OrderSearchBar;
